import { render, staticRenderFns } from "./EditTwilioNumber.vue?vue&type=template&id=6c1543ce"
import script from "./EditTwilioNumber.vue?vue&type=script&lang=js"
export * from "./EditTwilioNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./EditTwilioNumber.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c1543ce')) {
      api.createRecord('6c1543ce', component.options)
    } else {
      api.reload('6c1543ce', component.options)
    }
    module.hot.accept("./EditTwilioNumber.vue?vue&type=template&id=6c1543ce", function () {
      api.rerender('6c1543ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/candidates/views/EditTwilioNumber.vue"
export default component.exports